import DisabledOrPrivateInfo from './DisabledOrPrivateInfo';
import DisabledOrPrivateInfoContainer from './DisabledOrPrivateInfo.container';
import DisabledOrPrivateInfoV2 from '../../lego.editor_comment/DisabledOrPrivateInfo';
import withFeatureBranch from '@wix/da-react-context/pkg/flags/withFeatureBranch';
export default withFeatureBranch({
    editor_comment: DisabledOrPrivateInfoV2
})(DisabledOrPrivateInfoContainer(DisabledOrPrivateInfo));

//# sourceMappingURL=index.js.map